var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15958_36946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1768 24.7916C29.7245 24.622 29.4041 24.1885 29.3853 23.6985C29.3476 22.5678 29.2722 20.2498 29.2345 16.5749C29.2157 13.1638 31.3641 9.35703 34.8316 10.092C38.7138 10.9401 39.1473 16.5184 34.1532 25.1308C33.8328 25.6773 33.1921 25.9412 32.6079 25.7339L30.1768 24.7916Z",
    fill: "#1167ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2719 31.1434C31.7186 31.1434 32.8914 29.9706 32.8914 28.5238C32.8914 27.0771 31.7186 25.9043 30.2719 25.9043C28.8252 25.9043 27.6523 27.0771 27.6523 28.5238C27.6523 29.9706 28.8252 31.1434 30.2719 31.1434Z",
    fill: "#1167ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8477 33.7056C22.2623 33.4418 22.4885 32.9707 22.4131 32.4807C22.2247 31.3688 21.8477 29.0696 21.1316 25.4701C20.472 22.1344 17.6075 18.8176 14.366 20.231C10.7288 21.8329 11.4073 27.3924 18.0221 34.8364C18.4367 35.3075 19.134 35.4394 19.6617 35.1191L21.8666 33.7245L21.8477 33.7056Z",
    fill: "#1167ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4887 40.0008C23.9354 40.0008 25.1082 38.828 25.1082 37.3813C25.1082 35.9345 23.9354 34.7617 22.4887 34.7617C21.0419 34.7617 19.8691 35.9345 19.8691 37.3813C19.8691 38.828 21.0419 40.0008 22.4887 40.0008Z",
    fill: "#1167ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15958_36946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoStep);
export default __webpack_public_path__ + "static/media/info_step.5d48e3162312b101eefebc221dc983c9.svg";
export { ForwardRef as ReactComponent };